import http from "@/utils/http";

export default {
  users: {
    list() {
      return http.get("/api/user/list/");
    },
    create(user) {
      return http.post("/api/user/create/", user);
    },
    update(user) {
      return http.post(`/api/user/${user.id}/update/`, user);
    },
    delete(userId) {
      return http.post(`/api/user/${userId}/delete/`);
    },
    lastLoginsList() {
      return http.get("/api/user/last-logins/");
    }
  },
  sensors: {
    getlimits(source) {
      return http.get(`/api/common/${source}/sensors/limits/`);
    },
    updateLimit(source, limit) {
      return http.post(`/api/common/${source}/sensors/limits/update/`, limit);
    },
    createLimit(source, limit) {
      return http.post(`/api/common/${source}/sensors/limits/create/`, limit);
    },
    deleteLimit(source, limit) {
      return http.post(`/api/common/${source}/sensors/limits/delete/`, limit);
    }
  },
  formulas: {
    getFormulas(source) {
      return http.get(`/api/common/${source}/sensors/formulas/`);
    },
    updateFormulas(source, formulas) {
      return http.post(`/api/common/${source}/sensors/formulas/update/`, {
        formulas
      });
    }
  }
};
